export default __webpack_public_path__ + "static/terrain-1e50da889e46db929119df82f9c624c0.webp";